import React from 'react';
import PropTypes from 'prop-types';
import { graphql, gql, compose } from 'react-apollo';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './CancellationPoliciesShared.css';
import CancellationPolicySharedForm from '../../../components/siteadmin/CancellationPolicySharedForm';
import Loader from '../../../components/Loader';

const GET_CANCELLATION_POLICY_SHARED = gql`
    query getCancellationPolicyShared {
        getCancellationPolicyShared {
            id
            allowOwner
            allowOwner_en
            allowOwner_fr
            allowOwner_it
            allowOwner_pt
            
            cancellationCheckIn
            cancellationCheckIn_en
            cancellationCheckIn_fr
            cancellationCheckIn_it
            cancellationCheckIn_pt
            
            cancellationCheckOut
            cancellationCheckOut_en
            cancellationCheckOut_fr
            cancellationCheckOut_it
            cancellationCheckOut_pt
            
            cancellationDescription
            cancellationDescription_en
            cancellationDescription_fr
            cancellationDescription_it
            cancellationDescription_pt
            
            cancellationDesc1
            cancellationDesc1_en
            cancellationDesc1_fr
            cancellationDesc1_it
            cancellationDesc1_pt
            
            cancellationDesc2
            cancellationDesc2_en
            cancellationDesc2_fr
            cancellationDesc2_it
            cancellationDesc2_pt
            
            cancellationDesc3
            cancellationDesc3_en
            cancellationDesc3_fr
            cancellationDesc3_it
            cancellationDesc3_pt
            
            cancellationTripStart
            cancellationTripStart_en
            cancellationTripStart_fr
            cancellationTripStart_it
            cancellationTripStart_pt
            
            cancellationDesc4
            cancellationDesc4_en
            cancellationDesc4_fr
            cancellationDesc4_it
            cancellationDesc4_pt
            
            cancellationDesc5
            cancellationDesc5_en
            cancellationDesc5_fr
            cancellationDesc5_it
            cancellationDesc5_pt
            
            cancellationDesc6
            cancellationDesc6_en
            cancellationDesc6_fr
            cancellationDesc6_it
            cancellationDesc6_pt
            
            cancellationReview
            cancellationReview_en
            cancellationReview_fr
            cancellationReview_it
            cancellationReview_pt
            
            cancellationDesc7
            cancellationDesc7_en
            cancellationDesc7_fr
            cancellationDesc7_it
            cancellationDesc7_pt
        }
    }
`;

class CancellationPoliciesShared extends React.Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
    };

    render() {
        const { data: { loading, getCancellationPolicyShared }, title } = this.props;

        if (loading) {
            return <Loader type={"text"} />;
        }

        const initialValues = getCancellationPolicyShared || {};

        return (
            <CancellationPolicySharedForm
                initialValues={initialValues}
                title={title}
            />
        );
    }
}

export default compose(
    withStyles(s),
    graphql(GET_CANCELLATION_POLICY_SHARED, {
        options: {
            ssr: false,
            fetchPolicy: 'network-only'
        }
    }),
)(CancellationPoliciesShared);
